module.exports = __webpack_public_path__ + "images/79d8f24a06ae7ee1a4600f31c97b4e6c.jpg";